import { safeDefine } from "../../registration/safe-define.js";
import { TitleElement } from "../../ui/title/element.js";
//#region src/define/ui/title.ts
safeDefine(TitleElement);
//#endregion

//# sourceMappingURL=title.js.map